<template>

  <table class="rwd-table table-shadow order-detail-table">
    <colgroup>
      <col span="1" style="width: 5%;">
      <col span="1" style="width: 20%;">
      <col span="1" style="width: 5%;">
      <col span="1" style="width: 10%;">
      <col span="1" style="width: 10%;">
      <col span="1" style="width: 15%;">
      <col span="1" style="width: 10%;">
      <col span="1" style="width: 15%;">
      <col span="1" style="width: 10%;">
    </colgroup>
    <tbody>
    <tr>
      <th>{{ $t('frontend-mtg.area_riservata.table.th_8') }}</th>
      <th>{{ $t('frontend-mtg.area_riservata.table.th_9') }}</th>
      <th>{{ $t('frontend-mtg.area_riservata.table.th_10') }}</th>
      <th>{{ $t('frontend-mtg.area_riservata.table.th_11') }}</th>
      <th>{{ $t('frontend-mtg.area_riservata.table.th_12') }}</th>
      <th>{{ $t('frontend-mtg.area_riservata.table.th_14') }}</th>
      <th>{{ $t('frontend-mtg.area_riservata.table.th_15') }}</th>
      <th>{{ $t('frontend-mtg.area_riservata.table.th_16') }}</th>
      <th class="align-right">{{ $t('frontend-mtg.area_riservata.table.th_17') }}</th>
    </tr>

    <!-- LIST -->
    <tr v-for="item in items">
      <td :data-th="$t('frontend-mtg.area_riservata.table.th_8')">
        <!-- TODO: migliorare riga ordine -->
        <span class="td-content">{{ item.line_number }}</span>
      </td>
      <td :data-th="$t('frontend-mtg.area_riservata.table.th_9')">
        <span class="td-content">
          {{ item.name }}
          <ul>
            <li v-if="item.code_product"><strong>{{ $t('frontend-mtg.area_riservata.ordini.vr_codice_articolo') }}</strong> {{ item.code_product }}</li>
            <li v-if="item.description"><strong>{{ $t('frontend-mtg.area_riservata.ordini.vs_descrizione_articolo') }}</strong> {{ item.description }}</li>
          </ul>
        </span>
      </td>
      <td :data-th="$t('frontend-mtg.area_riservata.table.th_10')">
        <span class="td-content">{{ item.quantity }}</span>
      </td>
      <td :data-th="$t('frontend-mtg.area_riservata.table.th_11')">
        <span class="td-content">
            <span class="price-label">{{ item.price }} <small>{{ item.code_iso }}</small></span>
        </span>
      </td>
      <td :data-th="$t('frontend-mtg.area_riservata.table.th_12')">
        <span class="td-content">
            <span class="price-label">{{ item.total_amount }} <small>{{ item.code_iso }}</small></span>
        </span>
      </td>
<!--      <td :data-th="$t('frontend-mtg.area_riservata.table.th_13')">-->
<!--        <span class="td-content">-->
<!--            Price according to Offer: 2022/0648 -r1-->
<!--        </span>-->
<!--     </td>-->
      <td :data-th="$t('frontend-mtg.area_riservata.table.th_14')">
        <span class="td-content">{{ item.expected_delivery_date }}</span>
      </td>
      <td :data-th="$t('frontend-mtg.area_riservata.table.th_15')">
       <span class="td-content">{{ item.code_nomenclatura }}</span>
      </td>
      <td :data-th="$t('frontend-mtg.area_riservata.table.th_16')">
        <span class="td-content">
          <div v-if="item.progress !== null" class="radial-progress" :data-progress="item.progress">
              <div class="circle">
                  <div class="mask full">
                      <div class="fill"></div>
                  </div>
                  <div class="mask half">
                      <div class="fill"></div>
                      <div class="fill fix"></div>
                  </div>
              </div>
              <div class="inset"></div>
          </div>
          <span v-else>-</span>
        </span>
      </td>
      <td :data-th="$t('frontend-mtg.area_riservata.table.th_17')" class="rwd-td-small align-right">
        <span class="td-content">
          <span :class="item.process_status_color + ' stato'" :uk-tooltip="'title: ' + $t('frontend-mtg.area_riservata.ordini.'+item.process_status_tag)"></span>
        </span>
      </td>

    </tr>
    </tbody>
  </table>
  

</template>

<script>
import DataGridResults from 'js/theme-mixins/DataGridResults';

export default {
  mixins: [DataGridResults],
  computed: {
    itemNumber() {
      return this.items.length
    }
  },
  watch: {
    // items() {
    //   this.$nextTick(function () {
    //     document.querySelectorAll(".professional-card-image").forEach(img => {
    //       img.classList.add("lazyload");
    //     })
    //   })
    // }
  },
}
</script>



// WEBPACK FOOTER //
// public/themes/frontend/mtg/extensions/rubinred/collections/assets/js/OrderItemsDataGridResults.vue